import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import {  LargeButton, PrimaryButton } from "../../../../Constant";
import { LARGE_BUTTONS, LARGE_BUTTONS_LIST } from "../../../../Data/Buttons/DefaultStyle";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonButton from "../Common/CommonButton";

const LargeButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={LargeButton} span={LARGE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="lg" color="primary" id="Tooltip-8">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-8" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-primary btn-lg</ToolTip>
          {LARGE_BUTTONS_LIST.map((data, index) => (
            <CommonButton key={index} item={data} size="lg" />
          ))}
        </CardBody>
      </Card>
    );
};

export default LargeButtons;
